import React, { StrictMode, useEffect } from "react";
import './App.css';
import AppRoutes from './routes/AppRoutes';
import { AuthProvider } from "./context/AuthContext";


function App() {
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", "light");
    localStorage.removeItem("dashboard-theme");
  }, []);

  return (
    <>
    <StrictMode>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </StrictMode>
    </>
  )
}

export default App;
